import { memo } from 'react';
import { BulkPaymentCompleteTemplate } from 'components/templates/BulkPaymentCompleteTemplate';

type Props = {};

export const BulkPeriodicPaymentComplete = memo((_props: Props) => {
	return <BulkPaymentCompleteTemplate />;
});
